import React from 'react';
import { Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import LoginForm from './LoginForm';

const { Header, Content } = Layout;

interface LoginPageProps {
  onLogin: (username: string, password: string) => Promise<void>;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <Header style={{ 
        background: 'rgba(0, 21, 41, 0.9)', 
        color: 'white', 
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div 
          style={{ 
            color: 'white', 
            fontSize: '20px', 
            fontWeight: 'bold',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center'
          }}
          onClick={() => navigate('/')}
        >
          🔮 慧卜
        </div>
        <div style={{ color: 'white' }}>
          没有账户？
          <span 
            style={{ 
              marginLeft: '8px', 
              color: '#40a9ff', 
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
            onClick={() => navigate('/register')}
          >
            立即注册
          </span>
        </div>
      </Header>
      <Content style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        padding: '40px'
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '20px',
          padding: '40px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
          backdropFilter: 'blur(10px)',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{ 
            textAlign: 'center', 
            marginBottom: '30px' 
          }}>
            <h2 style={{ 
              fontSize: '24px', 
              color: '#333',
              marginBottom: '8px'
            }}>
              登录您的账户
            </h2>
            <p style={{ 
              color: '#666',
              margin: 0
            }}>
              开始您的高效塔罗解读之旅
            </p>
          </div>
          
          <LoginForm
            onLogin={onLogin}
            onSwitchToRegister={() => navigate('/register')}
            showSwitchButton={false}
          />
        </div>
      </Content>
    </Layout>
  );
};

export default LoginPage;